import React from 'react';

import { observer } from 'mobx-react';

import { OrderDetailsLayout } from '../../../components/checkout/OrderDetailsLayout/OrderDetailsLayout';
import { TimerBlock } from './TimerBlock/TimerBlock';
import { PriceInfo } from './PriceInfo/PriceInfo';
import { DetailsTable } from '../../../components/checkout/DetailsTable/DetailsTable';
import { checkoutStore } from '../../../stores/checkoutStore';
import { getPriceForSubscription } from './utils/getPriceForSubscription';
import { getRouteParam } from '../../../../shared/utils/angularUtils';
import { checkoutQueryParams } from '../../../constants/pathQueryParams';

const OrderDetailsBlock = observer(() => {
  const { checkoutInfo, subscriptionTypeFlags } = checkoutStore;

  const consultationType = getRouteParam(checkoutQueryParams.consultationType);

  if (!checkoutInfo) {
    return null;
  }

  const { subscription, checkoutDetails, coach, tax, entity } = checkoutInfo;

  return (
    <OrderDetailsLayout>
      {!subscriptionTypeFlags.SCAN_IQ && <TimerBlock />}
      <PriceInfo />
      <DetailsTable
        targetName={subscription.name}
        totalAmount={checkoutDetails.totalAmount}
        taxAmount={checkoutDetails.taxAmount}
        price={getPriceForSubscription(subscription, subscriptionTypeFlags)}
        businessName={entity.businessName}
        coach={coach}
        tax={tax}
        consultationType={consultationType}
      />
    </OrderDetailsLayout>
  );
});

export { OrderDetailsBlock };
